<div class="ms-0 p-0 w-100">
  <div class="row justify-content-between flex-nowrap">
    <div class="page-header">
      @if (breadcrumbs.length > 0) {
        <div class="page-breadcrumbs">
          @for (segment of breadcrumbs; track $index; let last = $last) {
            @if (segment.route) {
              <a [routerLink]="segment.route" [fragment]="segment.fragment">
                {{ segment.name }}
              </a>
            } @else {
              <span>
                {{ segment.name }}
              </span>
            }

            @if (!last) {
              /
            }
          }
        </div>
      }
      @if (pageHeading) {
        <h3 class="page-heading">
          {{ pageHeading }}
        </h3>
      }
    </div>

    @if (currentRegister) {
      <div class="col-auto header-bar selectors justify-content-end">
        @if (currentRegime || currentPeriod) {
          @if (currentRegime && showRegimeSelector) {
            <div class="regime-selector">
              <app-regime-selector
                [selectedRegister]="currentRegister"
              ></app-regime-selector>
            </div>
          }

          @if (currentPeriod && showCalendarSelector) {
            <div class="period-selector">
              @if (currentPeriod.useFY) {
                <app-fy-selector
                  [selectedRegister]="currentRegister"
                ></app-fy-selector>
              } @else {
                <app-calendar-selector
                  [selectedRegister]="currentRegister"
                ></app-calendar-selector>
              }
            </div>
          }
        }

        <div>
          <app-search-bar
            placeholder="Search Assets..."
            [searchService]="assetsService"
            [resultLink]="assetLink"
            [moreResultsLink]="moreResultsLink"
          ></app-search-bar>
        </div>
      </div>
    }
  </div>
</div>
